import React from 'react';
import styled from 'styled-components';
import { Color } from '@/constants/Color';

const Headline = styled.p`
  color: ${Color.secondary};
  font-weight: 700;
  font-size: 21px;
  letter-spacing: 0.08em;
  white-space: pre-line;
  margin: 0;
  padding: 0;

  &.left {
    text-align: left;
  }
  &.center {
    text-align: center;
  }
  &.right {
    text-align: right;
  }
  &.danger {
    color: ${Color.danger};
  }
  &.white {
    color: ${Color.white};
  }
`;

type Props = {
  title: string;
  align?: string;
  theme?: string;
};

H1.defaultProps = {
  align: 'left',
  theme: 'secondary',
};

export default function H1(props: Props) {
  return <Headline className={`h1 ${props.align} ${props.theme}`}>{props.title}</Headline>;
}
